import { render, staticRenderFns } from "./section-item.vue?vue&type=template&id=1b40c426"
import script from "./section-item.vue?vue&type=script&lang=js"
export * from "./section-item.vue?vue&type=script&lang=js"
import style0 from "./section-item.vue?vue&type=style&index=0&id=1b40c426&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports